import React from 'react';
import './NotificationPreferences.css';

const PREFERENCES = [
  {
    key: 'bookingConfirmation',
    title: 'Booking confirmations',
    description: 'Send an email when an appointment is confirmed.'
  },
  {
    key: 'appointmentReminders',
    title: 'Appointment reminders',
    description: 'Remind clients before their scheduled appointment.'
  },
  {
    key: 'schedulingUpdates',
    title: 'Schedule changes',
    description: 'Notify clients when an appointment changes.'
  },
  {
    key: 'depositConfirmation',
    title: 'Deposit confirmations',
    description: 'Confirm when a deposit payment is received.'
  },
  {
    key: 'balanceConfirmation',
    title: 'Balance confirmations',
    description: 'Confirm when the remaining balance is paid.'
  },
  {
    key: 'checkInLinkRequest',
    title: 'Check-in links',
    description: 'Send automated check-in links before appointments when enabled in booking settings.'
  }
];

const NotificationPreferences = ({ settings, onUpdate }) => {
  const getNotificationValue = (settingKey) =>
    settings.notifications?.[settingKey] ?? false;

  const handleToggle = (settingKey) => {
    const updatedSettings = {
      ...settings,
      notifications: {
        ...settings.notifications,
        [settingKey]: !getNotificationValue(settingKey)
      }
    };

    if (settingKey === 'appointmentReminders') {
      const newReminderEnabled = !getNotificationValue(settingKey);
      updatedSettings.reminderEnabled = newReminderEnabled;

      if (newReminderEnabled) {
        updatedSettings.reminders = Array.isArray(settings.reminders) && settings.reminders.length > 0
          ? settings.reminders
          : [24];
      }
    }

    onUpdate(updatedSettings);
  };

  return (
    <div className="notification-preferences">
      {PREFERENCES.map((preference) => (
        <div key={preference.key} className="notification-preference-row">
          <div className="notification-preference-copy">
            <h3 className="notification-preference-title">{preference.title}</h3>
            <p className="notification-preference-description">{preference.description}</p>
          </div>

          <label
            className="notification-preference-checkbox"
            onClick={(event) => event.stopPropagation()}
          >
            <input
              type="checkbox"
              checked={getNotificationValue(preference.key)}
              onChange={() => handleToggle(preference.key)}
              aria-label={preference.title}
            />
          </label>
        </div>
      ))}
    </div>
  );
};

export default NotificationPreferences;